'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _interceptUpdater = require('coact-utils/interceptUpdater');

var _interceptUpdater2 = _interopRequireDefault(_interceptUpdater);

var _stateSpliter = require('coact-utils/stateSpliter');

var _stateSpliter2 = _interopRequireDefault(_stateSpliter);

var _ConditionEditor = require('./ConditionEditor');

var _ConditionEditor2 = _interopRequireDefault(_ConditionEditor);

var _TextCondition = require('./TextCondition');

var _TextCondition2 = _interopRequireDefault(_TextCondition);

var _NumberCondition = require('./NumberCondition');

var _NumberCondition2 = _interopRequireDefault(_NumberCondition);

var _DateCondition = require('./DateCondition');

var _DateCondition2 = _interopRequireDefault(_DateCondition);

var _CheckboxCondition = require('./CheckboxCondition');

var _CheckboxCondition2 = _interopRequireDefault(_CheckboxCondition);

var _SelectCondition = require('./SelectCondition');

var _SelectCondition2 = _interopRequireDefault(_SelectCondition);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapInputComps = {
  text: _TextCondition2.default,
  number: _NumberCondition2.default,
  date: _DateCondition2.default,
  checkbox: _CheckboxCondition2.default,
  select: _SelectCondition2.default
};
function getDefaultInput(_ref) {
  var type = _ref.type,
      options = _ref.options,
      reference = _ref.reference;

  // if (isRefType(type)) return 'select'
  if (reference) return 'select';
  if (options) return 'select';
  if (type === 'Array') return 'select';
  if (type === 'Date') return 'date';
  if (type === 'Number') return 'number';
  if (type === 'Boolean') return 'checkbox';

  return 'text';
}

function selectEditor(_ref2) {
  var schema = _ref2.schema;

  var key = getDefaultInput(schema);
  return mapInputComps[key] ? mapInputComps[key] : function () {
    return null;
  };
}

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  query: _propTypes.object,
  setQuery: _propTypes.func.isRequired,
  schema: _propTypes.object.isRequired,
  Editor: _propTypes.func
}), (0, _withProps2.default)(function (props) {
  return {
    Editor: props.Editor || selectEditor(props)
  };
}), (0, _withState2.default)('value', 'onChange', {}), (0, _interceptUpdater2.default)('onChange', function (_ref3) {
  var setQuery = _ref3.setQuery,
      Editor = _ref3.Editor;
  return function (value) {
    setQuery(Editor.buildQuery(value));
    return value;
  };
}), (0, _withProps2.default)(function (_ref4) {
  var value = _ref4.value,
      onChange = _ref4.onChange,
      schema = _ref4.schema;
  return {
    linkState: (0, _stateSpliter2.default)(value, onChange),
    schema: _ramda2.default.omit('disabled', schema)
  };
}), (0, _exposeProps2.default)(['value', 'onChange', 'linkState', 'Editor', 'schema']));

exports.default = enhancer(_ConditionEditor2.default);


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/QueryEditor/ConditionEditor/index.js
// module id = 1719
// module chunks = 0